export enum LoginType {
  NORMAL = 'normal',
  INSPECTOR = 'inspector',
}
